import type { ExportBatch } from '../types.js'
import { formatWhen, personLabel, spanLabel } from '../labels.js'

/** The receipts of a facility's exports, newest first: what HR received, when, from whom, and how many workers it covered. */
export function ReceiptList({ receipts, empty }: { receipts: readonly ExportBatch[]; empty: string }) {
  if (receipts.length === 0) {
    return <p className="text-[11px] text-ink-mid">{empty}</p>
  }
  return (
    <ul className="divide-y divide-marine/10 border border-marine/15 bg-white text-xs">
      {receipts.map((receipt) => (
        <li key={receipt.batchId} className="flex flex-wrap items-center gap-x-3 gap-y-1 px-3 py-2">
          <span className="font-bold text-ink">
            {receipt.workers} {receipt.workers === 1 ? 'worker' : 'workers'}
          </span>
          <span className="text-ink-mid">{spanLabel(receipt.span)}</span>
          <span className="text-ink-mid">
            {formatWhen(receipt.generatedAt)} · {personLabel(receipt.generatedBy)}
          </span>
        </li>
      ))}
    </ul>
  )
}
